"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

var imgBox = function imgBox(theme) {
  return /*#__PURE__*/(0, _react.css)("width:", (0, _util.rem)(120), ";height:", (0, _util.rem)(120), ";border-radius:50%;background:100% 100%/cover no-repeat;position:relative;background-color:", theme.color.monochrome.light, ";&>*:not(input){width:100%;height:100%;border-radius:inherit;&:not(:hover)>:nth-of-type(2){visibility:hidden;opacity:0;}}button{position:absolute;top:0;left:0;width:100%;height:100%;background-color:rgba(", theme.color.monochrome.black_rgba, ", 0.8);display:flex;flex-direction:column;justify-content:center;align-items:center;color:", theme.color.monochrome.white, ";line-height:", theme.lineHeight.leadingSnug, ";cursor:pointer;visibility:hidden;opacity:0;transition:opacity 0.6s;border-radius:inherit;svg{width:", (0, _util.rem)(32), ";height:", (0, _util.rem)(32), ";}}&:hover{button{visibility:visible;opacity:1;}}" + (process.env.NODE_ENV === "production" ? "" : ";label:imgBox;"));
};

var dropdown = /*#__PURE__*/(0, _react.css)("min-width:", (0, _util.rem)(128), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:dropdown;"));

var defaultPictureWrapper = function defaultPictureWrapper(theme) {
  return /*#__PURE__*/(0, _react.css)("display:flex;align-items:center;justify-content:center;position:absolute;top:0;left:0;width:100%;height:100%;color:", theme.color.monochrome.white, ";font-size:", theme.fontSize.x8large, ";font-weight:", theme.fontWeight.bold, ";svg{color:", theme.color.monochrome.mediumDark, ";width:", theme.spacing[16], ";height:", theme.spacing[16], ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultPictureWrapper;"));
};

var styles = {
  imgBox: imgBox,
  dropdown: dropdown,
  defaultPictureWrapper: defaultPictureWrapper
};
exports.styles = styles;
//# sourceMappingURL=PhotoUploader.styles.js.map